<div class="layoutblock searchresultListContainer">
    <div class="searchresultListSideLeft">  
        <div class="circle-icon">
            <div>
                <img hisImage="PUBLICATION" class="inlineicon" [title]="'fs.res.publication.Publication' | hisUi">
            </div>          
        </div>
    </div>
	
    <div class="searchresultListpageCenter">
        <div class="vcardSearchresult">
            <h2>{{'fs.res.publication.search.found' | hisUi}}</h2>
            
            <button *ngIf="showSwitchRepresentationLink" (click)="switchAndClearListTable(compName, null)" class="transparent bottomRight">
        		<img hisImage="table" class="inlineicon" [title]=" ">
            	<span>{{'view.unit_template.connect_orgunits_index' | hisUi}}</span>
			</button>
			
			<div class="clearerSpaceAbove1Em"></div>	
			
			<span appScrollwithme class="genericSearchButtons">
                <!-- Standard buttons -->
				<button *ngIf="showNewSearchButton" type="submit" iconPos="left" (click)="hisSearchResultComponent.newSearch()">
			 		<span>{{'de.his.javang.newsearch'|hisUi}}</span>
				</button>
				<button *ngIf="showChangeSearchButton" type="submit" iconPos="left" (click)="hisSearchResultComponent.changeSearch()">
			 		<span>{{'de.his.javang.changesearch'|hisUi}}</span>
				</button>
			</span>
	
			<his-job-starter *ngIf="hisSearchResultComponent.doShowJobStarter"
				[key]="hisSearchResultComponent.jobStarterKey"
				[search]="hisSearchResultComponent.search"
				[searchConfigFile]="hisSearchResultComponent.searchConfigFile"
				[selectedOptions]="hisSearchResultComponent.selectedOptions">
			</his-job-starter>
	
			<div class="clearerSpaceAbove1Em"></div>
        </div>
        <div class="clearerSpaceAbove1Em"></div>
        <div class="clearerSpaceAbove1Em"></div>
        
        <div class="labelVcardSearchresult">
            <span>
                {{'de.his.faces.tags.table.datascroller.numRowsFound.label' | hisUi}}
                {{'de.his.faces.tags.table.datascroller.numRowsFound.' + (totalRecords === 1 ? 'record' : 'records') |	hisUi: totalRecords}} |
                {{'de.his.faces.tags.table.datascroller.numRowsFound.page' | hisUi: currentPage : totalPage}}
            </span>
        </div>
  
		<div class="infoMessage" *ngIf="hisSearchResultComponent.resultRowsLimitedMessage">{{ hisSearchResultComponent.resultRowsLimitedMessage | hisUi : hisSearchResultComponent.maxResultRows }}</div>

        <!-- Layout SearchResultList Inhalt -->
        <ul class="searchResultList">
            <li *ngFor="let pub of data" class="resultListDetail">
                <res-publication-search-result-list-element
                    [pub]="pub"
                    [showEditButton]="showEditButton"
                    [showDeleteButton]="showDeleteButton"
                    [customActionButtonsTemplate]="customActionButtonsTemplate"
                    [disableActionButtons]="disableActionButtons"
                    [prevPage]="prevPage"
                    (delete)="onDelete($event)">
                </res-publication-search-result-list-element>
            </li>
        </ul>
        
        <div class="ui-paginator">
            <p-paginator [first]="first" [rows]="rowsPerPage" [totalRecords]="totalRecords" (onPageChange)="paginate($event)"></p-paginator>
        </div>
		<p></p>
		
		<div class="genericSearchButtons">
		  	<!-- Standard buttons -->
		  	<button *ngIf="showNewSearchButton" type="submit" iconPos="left" (click)="hisSearchResultComponent.newSearch()">
			 	<span>{{'de.his.javang.newsearch'|hisUi}}</span>
		  	</button>
		  	<button *ngIf="showChangeSearchButton" type="submit" iconPos="left" (click)="hisSearchResultComponent.changeSearch()">
			 	<span>{{'de.his.javang.changesearch'|hisUi}}</span>
		  	</button>
	    </div>
	    
	    <!-- #266607 In der Listenansicht muss "Die richtige Publikation ist nicht dabei? ..." mit in das div mit class="searchresultListpageCenter" -->
        <ng-container *ngIf="showNewPublicationMessage && auth.hasAnyArray(moduleOptions.RIGHT_CREATE)">
            <div class="clearer"></div>
            {{'fs.res.publication.search.notFoundQuestion' | hisUi}}<br/>
            <a routerLink="/pub/create" hisImage="context_add" [queryParams]="{showSearchButton: true, showBackButton: false}">{{'fs.res.publication.search.create' | hisUi}}</a>
        </ng-container>
	</div>
	
    <div class="searchresultListpageRight">
        <!--Platzhalter für leere rechte Spalte, wird ausgeblendet, wenn Breakpoint SMALL -->
    </div>
</div>
